export default __webpack_public_path__ + "static/media/icon_camera.e488e23b.svg";